export default {
  "AnswerCard": "_AnswerCard_clysf_1",
  "Title": "_Title_clysf_10"
};import "ni:sha-256;OBLggF2PrIZAA5TcwOFLgAhhTkcMqBEhryoE0NQhzNc";